<template>
  <v-dialog v-model="showModal" max-width="1000" persistent :retain-focus="false">
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer
        ref="validator"
        v-slot="{ handleSubmit }"
      >
        <v-card-title class="text-sm-left font-weight-bold">
          <template v-if="isCreate">Thêm mới người dùng</template>
          <template v-else>Cập nhật thông tin người dùng</template>

          <v-spacer />

          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <h3
              class="title-text-header text-left">Thông tin cá nhân</h3>
          <v-row>
            <v-col cols="12" md="4">
              <div class="upload-image upload-image--user">
                <v-tooltip bottom v-if="_.get(user, 'avatar.id', null)">
                  <template v-slot:activator="{ on }">
                    <v-btn class="delete-img" @click="deleteImage" icon small color="default" v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
                  </template>
                  <span>Xóa ảnh đại diện</span>
                </v-tooltip>
                <img
                  v-if="_.get(user, 'avatar.id', null)"
                  :src="_.get(user, 'avatar.filePath')"
                  @click="chooseImage"
                  style="width: 100%"
                />
                <v-img v-else src="@/assets/default-avatar.jpg" @click="chooseImage" />
                <input
                  ref="fileInput"
                  style="display: none"
                  type="file"
                  accept="image/*"
                  @input="onSelectFile"
                />
              </div>
            </v-col>
            <v-col cols="12" md="8">
              <v-row>
                <v-col cols="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    :rules="{ required: true, max:20, regex: regex.isUsername }"
                    name="Tên đăng nhập"
                  >
                    <v-text-field
                      v-model="user.username"
                      label="Tên đăng nhập *"
                      :error-messages="errors"
                      color="primary"
                      :readonly="!isCreate"
                    />
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    name="Email"
                    :rules="{ max:255, email: true, regex: regex.isEmail }"
                  >
                    <v-text-field
                      v-model="user.email"
                      label="Email"
                      :error-messages="errors"
                      color="primary"
                      type="email"
                    />
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    rules="required|max:255"
                    name="Họ và tên đệm"
                  >
                    <v-text-field
                      v-model="user.lastName"
                      label="Họ và tên đệm *"
                      :error-messages="errors"
                      color="primary"
                    />
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="6">
                  <validation-provider
                    v-slot="{ errors }"
                    class="mb-2"
                    rules="required|max:50"
                    name="Tên"
                  >
                    <v-text-field
                      v-model="user.firstName"
                      label="Tên *"
                      :error-messages="errors"
                      color="primary"
                    />
                  </validation-provider>
                </v-col>
                <v-col v-if="isCreate" cols="12" md="6">
                  <validation-provider
                    v-slot="{ errors, validate }"
                    :rules="{required: true, max: 20, passwordRules: regex.isPasswordStrong}"
                    name="Mật khẩu"
                    vid="password"
                    mode="eager"
                  >
                    <v-text-field
                      v-model="user.password"
                      label="Mật khẩu *"
                      :error-messages="errors"
                      color="primary"
                      :append-icon="visiblePassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="() => (visiblePassword = !visiblePassword)"
                      :type="visiblePassword ? 'password' : 'text'"
                      @input="validate"
                    />
                  </validation-provider>
                </v-col>
                <v-col v-if="isCreate" cols="12" md="6">
                  <validation-provider
                    v-slot="{ errors, validate }"
                    name="Nhập lại mật khẩu"
                    rules="required|confirmed:password"
                    mode="eager"
                  >
                    <v-text-field
                      v-model="user.confirm"
                      label="Xác nhận lại mật khẩu *"
                      :error-messages="errors"
                      color="primary"
                      :append-icon="visibleConfirmPassword ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="() => (visibleConfirmPassword = !visibleConfirmPassword)"
                      :type="visibleConfirmPassword ? 'password' : 'text'"
                      @input="validate"
                    />
                  </validation-provider>
                </v-col>
<!--                <v-col cols="12" md="6">-->
<!--                  <validation-provider-->
<!--                    v-slot="{ errors }"-->
<!--                    class="mb-2"-->
<!--                    rules="required"-->
<!--                    name="Giới tính"-->
<!--                  >-->
<!--                    <v-autocomplete-->
<!--                      v-model="user.gender"-->
<!--                      attach-->
<!--                      :items="userGenderOptions"-->
<!--                      :error-messages="errors"-->
<!--                      item-text="text"-->
<!--                      item-value="value"-->
<!--                      label="Giới tính *"-->
<!--                      color="primary"-->
<!--                    />-->
<!--                  </validation-provider>-->
<!--                </v-col>-->
                <v-col cols="12" md="6">
                  <validation-provider
                      v-slot="{ errors }"
                      class="mb-2"
                      name="Số di động"
                      :rules="{ regex: regex.isVNPhoneMobile }"
                  >
                    <v-text-field
                        v-model="user.phone"
                        label="Di động"
                        :error-messages="errors"
                        color="primary"
                        type="number"
                    />
                  </validation-provider>
                </v-col>
                <v-col cols="12" md="6">
                  <v-menu
                    ref="datePicker"
                    v-model="datePicker"
                    :close-on-content-click="false"
                    :return-value.sync="user.birthday"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="user.birthday"
                        color="primary"
                        label="Ngày sinh"
                        prepend-icon="mdi-calendar-outline"
                        readonly
                        v-on="on"
                      />
                    </template>

                    <v-date-picker
                      v-model="user.birthday"
                      color="secondary"
                      scrollable
                      @change="$refs.datePicker.save(user.birthday), datePicker = false"
                      :max="currentDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
<!--                <v-col cols="12" md="6">-->
<!--                  <validation-provider v-slot="{ errors }" rules="required" name="Phòng Ban">-->
<!--                    <v-autocomplete-->
<!--                        v-model="user.departmentId"-->
<!--                        :items="departments"-->
<!--                        :error-messages="errors"-->
<!--                        item-text="name"-->
<!--                        item-value="id"-->
<!--                        label="Phòng ban *"-->
<!--                        color="primary"/>-->
<!--                  </validation-provider>-->
<!--                </v-col>-->
<!--                <v-col cols="12" md="6" v-if="user.position === userPositions.SALE_LEADER">-->
<!--                  <validation-provider v-slot="{ errors }" name="Quản lý thêm" class="mb-2">-->
<!--                    <v-autocomplete-->
<!--                        v-model="user.listdepartmentId"-->
<!--                        :items="departmentsForSaleLeader"-->
<!--                        :error-messages="errors"-->
<!--                        item-text="name"-->
<!--                        item-value="id"-->
<!--                        label="Quản lý thêm"-->
<!--                        color="primary"-->
<!--                        multiple-->
<!--                        class="selectAll-group-department"-->
<!--                        clearable-->
<!--                        :disabled="!user.departmentId"-->
<!--                        eager-->
<!--                    >-->
<!--                      <template #prepend-item>-->
<!--                        <common-select-all-->
<!--                            v-model="user.listdepartmentId"-->
<!--                            :item="departmentsForSaleLeader"-->
<!--                            :items="departmentsForSaleLeader.map(s => s.id)"-->
<!--                        ></common-select-all>-->
<!--                      </template>-->
<!--                    </v-autocomplete>-->
<!--                  </validation-provider>-->
<!--                </v-col>-->

                <v-col cols="12" md="6">
                  <validation-provider
                      :rules="{ required: true }"
                      v-slot="{ errors }"
                      name="Nhóm quyền">
                    <v-autocomplete
                        v-model="user.roleIds"
                        :items="groupPermissionList"
                        :error-messages="errors"
                        item-text="name"
                        item-value="id"
                        label="Nhóm quyền *"
                        color="primary"
                        multiple
                        clearable
                    />
                  </validation-provider>
                </v-col>

                <v-col cols="12" md="6">
                  <validation-provider
                      v-slot="{ errors }"
                      :rules="{ required: true }"
                      name="Chức danh"
                  >
                    <v-autocomplete
                        v-model="user.position"
                        :items="userPositionOptions"
                        item-text="label"
                        item-value="id"
                        :error-messages="errors"
                        label="Chức danh *"
                        color="primary"
                        clearable
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <h3 class="title-text-header text-left">Thiết lập công cụ hỗ trợ</h3>
          <v-row class="px-2">
            <v-col cols="12" md="4">
              <validation-provider v-slot="{ errors }"
                                   name="Call center">
                <v-autocomplete
                    v-model="user.callcenter_id"
                    :items="callCenters"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    label="Call center *"
                    color="primary"
                    eager
                />
              </validation-provider>
            </v-col>
            <v-col v-if="user.callcenter_id !== 6" cols="12" md="4">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{
                    max: 10,
                    regex: regex.isNumber
                  }"
                  name="Máy lẻ"
              >
                <v-text-field
                    v-model.trim="user.ext"
                    label="Máy lẻ"
                    :error-messages="errors"
                    color="primary"
                />
              </validation-provider>
            </v-col>
            <v-col v-if="user.callcenter_id !== 6" cols="12" md="4">
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{
                    min: 6,
                    max: 20,
                    regex: regex.isPassword,
                  }"
                  name="Mật khẩu máy lẻ"
              >
                <v-text-field
                    v-model="user.extPassword"
                    label="Mật khẩu máy lẻ"
                    :error-messages="errors"
                    :append-icon="visibleExtPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="() => (visibleExtPassword = !visibleExtPassword)"
                    :type="visibleExtPassword ? 'password' : 'text'"
                    autocomplete="new-password"
                />
              </validation-provider>
            </v-col>
            <v-col  v-if="user.callcenter_id === 6" cols="12" md="4">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  :rules="{
                    max: 50,
                    regex: regex.isNumber
                  }"
                  name="Đầu số tổng đài"
              >
                <v-text-field
                    v-model.trim="user.fromNumber"
                    label="Đầu số tổng đài"
                    :error-messages="errors"
                    color="primary"
                />
              </validation-provider>
            </v-col>
          </v-row>

          <h3 class="title-text-header text-left">Tổ chức nhân sự</h3>
          <v-row
              v-if="checkAuthorization('user_update')"
              class="px-2">
            <v-col cols="12" class="mb-2" md="4">
              <v-autocomplete
                  v-model="user.ministryId"
                  :items="listMinistry"
                  item-text="name"
                  item-value="id"
                  label="Bộ phận"
                  hide-details
                  @change="getOrgChild()"
              />
            </v-col>
            <template v-for="(listOrg, index) in listOrgs">
              <v-col
                  v-if="listOrg.length"
                  cols="12" md="4" class="mb-2" :key="index">
                <v-autocomplete
                    v-model="orgIds[index].orgId"
                    :items="listOrg"
                    item-text="name"
                    item-value="id"
                    label="Nhánh"
                    prepend-inner-icon="mdi-chevron-right"
                    hide-details
                    @change="getOrgChild(orgIds[index].orgId, orgIds[index].id)"
                />
              </v-col>
            </template>
          </v-row>

          <v-row class="px-2" v-show="listRank.length && checkAuthorization('user_update')">
            <v-col class="mb-2" cols="12" md="4">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  name="Rank"
              >
                <v-autocomplete
                    v-model="user.rankId"
                    :items="listRank"
                    item-text="name"
                    item-value="id"
                    label="Lộ trình làm việc"
                    :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>

          <h3 class="title-text-header text-left">Phân loại tác nghiệp</h3>
          <v-row class="px-2">
            <v-col cols="12" md="4">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  name="Định danh người dùng"
              >
                <v-autocomplete
                    v-model="user.identify"
                    :items="identifyList"
                    :error-messages="errors"
                    item-text="name"
                    item-value="code"
                    label="Định danh người dùng"
                    clearable
                    eager
                    @change="changeValueIdentify"
                >
                </v-autocomplete>
              </validation-provider>
              </v-col>
            </v-row>
          <v-row
              v-if="checkAuthorization('user_update')"
              class="px-2">
            <v-col cols="12" md="4" v-if="isShowTypeSchool">
                  <validation-provider
                      v-slot="{ errors }"
                      name="Loại hình - Nhóm ngành">
                    <v-autocomplete
                        v-model="user.typeSchoolLevels"
                        :items="listTypeSchoolLevels"
                        :error-messages="errors"
                        item-text="name"
                        item-value="id"
                        label="Loại hình - Nhóm ngành"
                        color="primary"
                        multiple
                        clearable
                    >
                    <template v-slot:selection="data">
                      <div class="type-school">
                        {{ data.item.name_render }}
                      </div>
                      </template>
                    </v-autocomplete>
                  </validation-provider>
            </v-col>
            <v-col v-if="!isShowTypeSchool" cols="12" md="4">
              <validation-provider
                  v-slot="{ errors }"
                  :rules="{required: !user.identify}"
                  name="Loại hình"
                  class="mb-2">
                <v-autocomplete
                    v-model="user.typeId"
                    :items="listPictureType"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    label="Loại hình *"
                    color="primary"
                    class="selectAll-group-department"
                    @change="onChangeTypeSchool"
                    clearable
                    eager
                >
                </v-autocomplete>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4" v-if="!isShowTypeSchool">
              <validation-provider
                  v-slot="{ errors }"
                  name="Nhóm ngành"
                  class="mb-2">
                <v-autocomplete
                    v-model="user.schoolLevelId"
                    :items="listSchoolLevelByType"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    label="Nhóm ngành"
                    color="primary"
                    class="selectAll-group-department"
                    clearable
                    eager
                    :disabled="Boolean(!user.typeId)"
                    @change="getProductGroupBySchoolLevel()"
                >
                </v-autocomplete>
              </validation-provider>
            </v-col>
            <v-col cols="12" md="4" v-if="isShowGroupProduct">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  name="Nhóm sản phẩm"
              >
                <v-autocomplete
                    v-model="user.productGroups"
                    :items="productGroupsFilter"
                    :error-messages="errors"
                    item-text="name"
                    item-value="id"
                    label="Nhóm sản phẩm"
                    color="primary"
                    multiple
                    class="selectAll-group-product"
                    clearable
                    :disabled="!user.schoolLevelId"
                    eager
                >
                  <template #prepend-item>
                    <common-select-all
                        v-model="user.productGroups"
                        :item="user.productGroups"
                        :items="productGroups.map(s => s.id)"
                    ></common-select-all>
                  </template>
                </v-autocomplete>
              </validation-provider>
            </v-col>
<!--            <v-col cols="12" md="4">-->
<!--              <div style="text-align: left; display: flex; align-items: center;">-->
<!--                <v-icon class="mr-2" aria-label="Close">mdi-account</v-icon>-->
<!--                <span>Người dùng quản trị</span>-->
<!--                <input-->
<!--                    @change="user.isManager ? user.isCTV = false : user.isCTV = null"-->
<!--                    style="height: 22px; width: 22px; margin-left: 12px"-->
<!--                    type="checkbox" v-model="user.isManager"/>-->
<!--              </div>-->
<!--              <div style="text-align: left; display: flex; align-items: center;">-->
<!--                <v-icon class="mr-2" aria-label="Close">mdi-account</v-icon>-->
<!--                <span>Đối tác</span>-->
<!--                <input-->
<!--                    @change="user.isCTV ? user.isManager = false : user.isManager = null"-->
<!--                    style="height: 22px; width: 22px; margin-left: 12px"-->
<!--                    type="checkbox" v-model="user.isCTV"/>-->
<!--              </div>-->

<!--            </v-col>-->
          </v-row>
<!--          <h3 class="title-text-header text-left">Định danh người dùng</h3>-->

<!--          <div v-if="newPICUser.id" style="color: red;">-->
<!--            Ấn LƯU LẠI sẽ chuyển contacts sang cho người phụ trách sau:-->
<!--            <span style="font-weight: bold">{{ newPICUser.fullName }}</span>-->
<!--          </div>-->
        </v-card-text>

        <v-card-actions class="group-btn--form">
          <v-btn color="success" @click.prevent="handleSubmit(saveUser)">Lưu lại</v-btn>
          <v-spacer />

          <v-btn color="primary" @click="hideModal">Hủy bỏ</v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
    <modal-change-user v-if="showModalChangeUser"
                       :showModalChangeUser="showModalChangeUser"
                       :user="user"
                        v-on:updateAfterChangePersonInCharge="updateAfterChangePersonInCharge">
    </modal-change-user>
  </v-dialog>
</template>
<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
import { formatDate } from '../../../helpers/utils';
import * as moment from 'moment'
import {
  regex,
  userPositions
} from '../../../helpers/constants';
import ModalChangeUser from "./ModalChangeUser";
const UserRepository = RepositoryFactory.get('user');
const ImageRepository = RepositoryFactory.get('image');
const ProductGroupRepository = RepositoryFactory.get('product_group');
const SchoolLevelRepository = RepositoryFactory.get('school_level')
const organizationMachineRepository = RepositoryFactory.get('organization_machine')
const typeRepository = RepositoryFactory.get('type')
const RoleRepository = RepositoryFactory.get('role')
const ContactRepository = RepositoryFactory.get('contact');
export default {
  components: {
    ModalChangeUser
  },
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    departments: {
      default: () => ([]),
    },
  },
  data() {
    return {
      datePicker: false,
      regex,
      showModal: false,
      user: {
        productGroups: [],
        onAssignContact: false,
        departmentId : '',
        schoolLevelId: [],
        ministryId: '',
        orgId: '',
        rankId: '',
        // isManager: false,
        typeId: '',
        // isCTV: false,
        position: ''
      },
      // isManager: false,
      isCreate: true,
      roles: [],
      productGroups: [],
      errorMessage: '',
      ProductGroupIds: [],
      rules: [
        value =>
          !value ||
          value.size < 2000000 ||
          'Kích thước hình đại diện phải nhỏ hơn 2 MB!'
      ],
      visibleExtPassword: true,
      visibleConfirmPassword: true,
      visiblePassword: true,
      allGroup: false,
      callCenters: [
        {
          id: '',
          name: 'Không chọn'
        },
        {
          id: 1,
          name: 'ePacific'
        },
        {
          id: 2,
          name: 'CareSoft'
        },
        {
          id: 3,
          name: 'Minh Phúc'
        },
        {
          id: 4,
          name: 'ODS'
        },
        // {
        //   id: 5,
        //   name: 'OMICALL'
        // },
        {
          id: 6,
          name: 'SUBIZ'
        },
      ],
      departmentsForSaleLeader : [],
      productGroupsFilter: [],
      listPictureType: [],
      schoolLevelList: [],
      listMinistry: [],
      listOrgs: [],
      listRank: [],
      orgIds: [],
      userPositionOptions: [{'id': 'staff', 'label': 'Nhân viên'}, {'id': 'lead', 'label': 'Lead'}],
      userPositions,
      identifyList: [
        {
          name: 'Quản trị',
          code: 'manager'
        },
        {
          name: 'Marketing',
          code: 'mkt'
        },
        {
          name: 'Đối tác',
          code: 'ctv'
        },
        {
          name: 'Outsource',
          code: 'outsource'
        }
      ],
      groupPermissionList: [],
      showModalChangeUser: false,
      newPICUser: {},
      suggestChangeModule: false,
      listTypeSchoolLevels: [],
      isShowTypeSchool:false,
      isShowGroupProduct:true,
      listTypeSchoolLevelsClone: [],
      listTYpeSchoolMkt: [],
      checkWarning: true
    };
  },
  async created() {
    await this.getProductGroupList();
    const resListSchoolLevels = await organizationMachineRepository.getListSchoolLevels()
    if (resListSchoolLevels.success ) {
        let listLevel = [
          {header:'Tất cả'},
          {
            name:"Tất cả(Xem 3 nhóm nghành như cũ)",
            name_render:"Tất cả - Tất cả(Xem 3 nhóm nghành như cũ)",
            id:'1000-1000'
          }
        ];
        let listLevelNotMKT = [];
        let data  = resListSchoolLevels.data
        this.listTypeSchoolLevelsClone = [];

        data.forEach(item => {
            item.schoolLevel = item.schoolLevel.map(item2 => {
              return {
                ...item2,
                id: `${item.id}-${item2.id}`,
                name_render: `${item.name}-${item2.name},`
              }
            })
            listLevel = [...listLevel,{header:item.name},...item.schoolLevel]
            listLevelNotMKT.push({header:item.name},...item.schoolLevel)

        })
        this.listTYpeSchoolMkt = listLevel;
        this.listTypeSchoolLevelsClone = listLevelNotMKT;
    }
    Bus.$on('user-show-user-form-new', async user => {
      this.user = _.cloneDeep(user)
      this.user.birthday = formatDate(user.birthday);
      this.user.identify = this.user.isManager ? 'manager'
          : this.user.isPartner ? 'ctv' : this.user.isMarketing ? 'mkt'
          : +this.user.identifier == 3 ? 'outsource' :  ''
      this.isShowTypeSchool = true
      this.isShowGroupProduct = false
      this.checkWarning = true
      // if(this.user.identify == "manager" || this.user.identify == "ctv") {
      //   this.isShowTypeSchool = false
      //   this.isShowGroupProduct = true
      // }
      this.listTypeSchoolLevels = this.listTypeSchoolLevelsClone;
      if (this.user.identify && this.user.identify !== 'mkt') {
        this.listTypeSchoolLevels = this.listTypeSchoolLevelsClone;
      } else if (this.user.identify && this.user.identify == 'mkt'){
        this.listTypeSchoolLevels = this.listTYpeSchoolMkt;
      }
      if (Object.keys(user).length === 0) {
        this.user.onAssignContact = false
      } else {
        this.user.onAssignContact = !this.user.offAssignContact
      }
      if (user.id) {
        this.isCreate = false;
        this.getDetailMinistryUser(user.id)
      } else {
        this.isCreate = true;
        this.orgIds = []
        this.listOrgs = []
        this.listRank = []
      }
      if(this.user?.userModule?.length) {
        this.user.typeSchoolLevels = this.user.userModule.map(item => `${item.typeId}-${item.schoolLevelId}`)
      }
      this.getDepartmentForFilter()
      this.showModal = true;
      this.getProductGroupBySchoolLevel()
    });
    this.getListSchoolLevel();
    this.getMinistry();
    this.getListType();
    this.getTopicList();

    Bus.$on('reset-product-group-user-form', () => {
      this.getProductGroupList()
    });
    Bus.$on('close-modal-change-user', () => {
      this.showModalChangeUser = false
      this.suggestChangeModule = false
      this.newPICUser = {}
    })
  },
  computed: {
    currentDate() {
      const d = new Date();
      return d.toISOString().slice(0, 10);
    },
    listSchoolLevelByType(){
      if(this.schoolLevelList.length > 0 && this.user.typeId){
          const result = this.schoolLevelList.find(school => school.id === this.user.typeId)
          return result.schoolLevel
      }else return []
    },
  },
  beforeDestroy() {
    Bus.$off('user-show-user-form-new')
    Bus.$off('reset-product-group-user-form')
  },
  methods: {
    changeValueIdentify(value){
      this.isShowTypeSchool = true
      this.isShowGroupProduct = false
      this.user.typeSchoolLevels = []
      this.user.typeId = null
      this.user.schoolLevelId = null
      this.changeModule();
    },
    deleteImage() {
      this.$set(this.user, 'avatar', null)
      this.$set(this.user, 'avatarId', null)
    },
    hideModal: function() {
      this.showModal = false;
      this.isCreate = true;
      this.errorMessage = '';
      this.$refs.validator.reset()
      this.newPICUser = {}
      this.suggestChangeModule = false
      this.isShowTypeSchool = false
    },

    async getProductGroupList() {
      const params = {
        limit: 100,
        status: 'active',
        schoolLevelId: this.$store.state.module.schoolLevelId,
        typeId: this.$store.state.module.typeId
      }
      const response = await ProductGroupRepository.list(params);
      if (response.success) {
        this.productGroups = _.get(response, 'data', [])
      }
    },
    chooseImage() {
      this.$refs.fileInput.click();
    },
    async onSelectFile() {
      const loader = this.$loading.show();
      const input = this.$refs.fileInput;
      const files = input.files;
      if (files && files.length) {
        await this.uploadOneFile(files[0]);
      }
      loader.hide();
    },
    async uploadOneFile(file) {
      const uploadResponse = await ImageRepository.upload(file);
      if (_.get(uploadResponse, 'success', false)) {
        const newImage = _.get(uploadResponse, 'data', {});
        const avatar = {
          id: _.get(newImage, 'id', null),
          filePath: _.get(newImage, 'filePath', '')
        };
        this.$set(this.user, 'avatar', avatar);
        this.$set(this.user, 'avatarId', avatar.id);
      } else {
        this.$swal('Upload ảnh đại diện không thành công');
      }
    },
    async saveUser() {
      if (this.isCreate) {
        let user = {
          username: _.trim(this.user.username),
          password: this.user.password,
          firstName: _.trim(this.user.firstName),
          lastName: _.trim(this.user.lastName),
          email: this.user.email,
          phone: this.user.phone,
          ext: _.trim(this.user.ext),
          extPassword: this.user.extPassword,
          birthday: this.user.birthday,
          avatarId: this.user.avatarId,
          callcenter_id: _.trim(this.user.callcenter_id) != '' ? this.user.callcenter_id : null,
          productGroups: this.user.productGroups,
          typeId: this.user.typeId,
          schoolLevelId: this.user.schoolLevelId,
          ministryId: this.user.ministryId,
          orgId: this.user.orgId,
          rankId: this.user.rankId,
          fromNumber: this.user.fromNumber,
          // isManager: this.user.isManager ? 1 : 0,
          // departmentId: this.user.departmentId,
          // isPartner: this.user.isCTV ? 1 : 0,
          // position: this.user.position,
          // listDeparment: this.user.position === userPositions.SALE_LEADER ? this.user.listdepartmentId : []
          roleIds: this.user.roleIds ? this.user.roleIds : [],
          identifier: this.user.identify == 'outsource' ? 3 : null,
          position: this.user.position ? this.user.position : '',
          typeSchoolLevels:this.user.typeSchoolLevels
        };

        if(this.user.identify == 'manager') {
          user.isManager = 1;
          user.isPartner = 0;
          user.isMarketing = 0;
        } else if(this.user.identify == 'ctv') {
          user.isManager = 0;
          user.isPartner = 1;
          user.isMarketing = 0;
        } else if(this.user.identify == 'mkt') {
          user.isManager = 0;
          user.isPartner = 0;
          user.isMarketing = 1;
        }

        const loader = this.$loading.show();
        const response = await UserRepository.createV2(user);
        loader.hide();
        if (!response.success) {
          this.errorMessage = _.get(response, 'message', '');
        } else {
          this.errorMessage = ''
          this.showModal = false;
          this.$swal({
            title: 'Thêm người dùng thành công',
            confirmButtonText: 'Đồng ý'
          }).then(() => {
            Bus.$emit('user-list-reload')
          });
        }
      } else {
        const loader = this.$loading.show();
        if(this.suggestChangeModule) {
            const responseChangeUser = await this.saveChange();
            if(responseChangeUser.error) {
                this.$swal({
                    title: 'Lỗi!',
                    text: _.get(responseChangeUser, 'message', '')
                });
                return
            }
            this.suggestChangeModule = false
        }

        const user = {
          firstName: _.trim(this.user.firstName),
          lastName: _.trim(this.user.lastName),
          email: this.user.email,
          phone: this.user.phone,
          ext: _.trim(this.user.ext),
          extPassword: this.user.extPassword,
          birthday: this.user.birthday,
          avatarId: this.user.avatarId,
          callcenter_id: _.trim(this.user.callcenter_id) != '' ? this.user.callcenter_id : null,
          productGroups: this.user.productGroups,
          typeId: this.user.typeId,
          schoolLevelId: this.user.schoolLevelId,
          ministryId: this.user.ministryId,
          orgId: this.user.orgId,
          rankId: this.user.rankId,
          fromNumber: this.user.fromNumber,
          // isManager: this.user.isManager ? 1 : 0,
          // departmentId: this.user.departmentId,
          // isPartner: this.user.isCTV ? 1 : 0,
          // position: this.user.position,
          // listDeparment: this.user.position === userPositions.SALE_LEADER ? this.user.listdepartmentId : []
          roleIds: this.user.roleIds ? this.user.roleIds : [],
          identifier: this.user.identify == 'outsource' ? 3 : null,
          position: this.user.position ? this.user.position : '',
          typeSchoolLevels:this.user.typeSchoolLevels,
          checkWarning: this.checkWarning
        };

        if(this.user.identify == 'manager') {
          user.isManager = 1;
          user.isPartner = 0;
          user.isMarketing = 0;
        } else if(this.user.identify == 'ctv') {
          user.isManager = 0;
          user.isPartner = 1;
          user.isMarketing = 0;
        } else if(this.user.identify == 'mkt') {
          user.isManager = 0;
          user.isPartner = 0;
          user.isMarketing = 1;
        }

        const response = await UserRepository.updateV2(this.user.id, user);
        loader.hide();
        if (response.status == 400 && response.message == 'require_change_person_in_charge') {
          // this.suggestChangeModule = true
          // this.showModalChangeUser = true

          this.checkWarning = false;
          this.$swal({
            type: 'warning',
            title: 'Cảnh báo',
            text: "Vui lòng chuyển contact ở module cũ cho NPT mới trước khi đổi module!"
          });
        } else if (!response.success) {
          this.errorMessage = _.get(response, 'message', '')
          this.suggestChangeModule = false
          this.newPICUser = {}
        } else {
          this.newPICUser = {}
          this.errorMessage = ''
          this.showModal = false
          this.suggestChangeModule = false
          this.$swal({
              title: 'Cập nhật người dùng thành công',
              confirmButtonText: 'Đồng ý',
            },
          ).then(() => {
            Bus.$emit('user-list-reload')
          })
        }
      }
    },
      async updateAfterChangePersonInCharge(newPICUser) {
        this.showModalChangeUser = false
        this.newPICUser = newPICUser
      },
    getProductGroupBySchoolLevel() {
      if(this.user.schoolLevelId) {
        this.productGroupsFilter = this.productGroups.filter(item => this.user.schoolLevelId == item.schoolLevelId)
      } else {
        this.productGroupsFilter = this.productGroups
      }
    },
    async getListSchoolLevel() {
      if(this.$store.state.listSchoolLevelDrawer) {
          this.schoolLevelList  = _.cloneDeep(this.$store.state.listSchoolLevelDrawer)
            return
      }

      const loading = this.$loading.show()
      const res = await SchoolLevelRepository.listTypeSchoolLevel()
      if (res.success) {
        this.schoolLevelList = _.get(res, 'data', [])
      } else {
        this.schoolLevelList = []
      }
      loading.hide()
    },
    async getMinistry() {
      const res = await organizationMachineRepository.listMinistryOnly()

      if (res.success) {
        this.listMinistry = _.get(res, 'data', [])
      } else {
        this.listMinistry = []
      }
    },

    async getOrgChild(parentId, id) {
      if (parentId) {
        this.user.orgId = parentId
        let index = this.orgIds.findIndex(o => o.id == id)

        if (index > -1) {
          this.listOrgs.splice(index + 1)
          this.orgIds.splice(index + 1)
        }
      } else {
        this.listOrgs = []
        this.orgIds = []
      }
      const res = await organizationMachineRepository.childOrg({
        ministryId: this.user.ministryId,
        parentId
      })

      if (res.success) {
        this.orgIds.push({
          id: moment().unix(),
          orgId: ''
        })
        if((_.get(res, 'data.children', [])).length) {
          this.listOrgs.push(_.get(res, 'data.children', []))
        }
        this.listRank = _.get(res, 'data.ranks', [])
      } else {
        this.listRank = []
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    },
    async getDetailMinistryUser(userId) {
      const res = await organizationMachineRepository.pathMinistryOfUser({userId: userId})

      if (res.success) {
        this.orgIds = _.get(res, 'data.orgIds', [])
        this.listOrgs = _.get(res, 'data.listOrgs', [])
        this.listRank = _.get(res, 'data.listRank', [])
        this.user.ministryId = _.get(res, 'data.ministryId', [])
        this.user.rankId = _.get(res, 'data.rankId', [])
        this.user.orgId = _.get(res, 'data.orgId', [])

      } else {
        this.$swal({
          title: 'Lỗi!',
          text: _.get(res, 'message', '')
        })
      }
    },
    async getListType() {
      const params = {
        limit: 1000
      }
      const response = await typeRepository.list(params);
      if (response.success) {
        this.listPictureType = _.get(response, 'data', [])
      }
    },
    getDepartmentForFilter() {
      let department = _.cloneDeep(this.departments);
      this.departmentsForSaleLeader = department.filter(item => item.id !== this.user.departmentId)
    },
    async getTopicList() {
      const loading = this.$loading.show()
      const params = {
        // limit: 1000
      };
      const response = await RoleRepository.listTopic(params);
      loading.hide()
      if (response.success) {
        let groupPermissionList = []
        _.get(response, "data", []).forEach( (topic, index) => {
          const { roles = [] } = topic
          groupPermissionList.push({
            header: topic.name,
            name: topic.name,
            topicId: topic.id
          })
          roles.forEach(role => {
            groupPermissionList.push(role)
          })
        });
        groupPermissionList = groupPermissionList.filter(item => item.name != '[ Xếp lớp ] Giáo viên tutor')
        this.groupPermissionList = groupPermissionList;
        console.log(groupPermissionList);
        Bus.$emit("group-permission-list", this.groupPermissionList)
      }
    },
      async saveChange() {
          return await ContactRepository.changeUserInCharge({
              oldPICUserId: this.user.id,
              newPICUserId: this.newPICUser.id
          });
      },
    changeModule() {
      if (this.user.identify && this.user.identify !== 'mkt') {
        this.listTypeSchoolLevels = this.listTypeSchoolLevelsClone;
      } else if (this.user.identify && this.user.identify == 'mkt'){
        this.listTypeSchoolLevels = this.listTYpeSchoolMkt;
      } else if (!this.user.identify) {
        this.listTypeSchoolLevels = this.listTypeSchoolLevelsClone;
      }
    }
  },
};
</script>
<style scoped>
.title-text-header {
  padding: 10px;
  background: #F3F2F9;
  margin: 20px 0px;
}
.type-school {
  color: #404346;
}
/deep/.v-subheader.theme--light {
  font-weight: bold;
}
</style>
